import BusinessInfo from "../pages/Compliance/BusinessInfo/BusinessInfo";
import PersonalInfo from "../pages/Compliance/PersonalInfo/PersonalInfo";
import PrivateLayout from "../layouts/PrivateLayout/PrivateLayout";
import BankDetails from "../pages/Compliance/BankDetails/BankDetails";
import BusinessRegistration from "../pages/Compliance/BusinessRegistration/BusinessRegistration";
import KnowYourBusiness from "../pages/Compliance/Kyb/KnowYourBusiness";
import Kyc from "../layouts/Kyc/Kyc";
import Overview from "../pages/Overview/Overview";
import Dashboard from "../pages/Dashboard/Dashboard";
import Transactions from "../pages/Business/Transactions/Transactions";
import Invoices from "../pages/Business/Invoices/Invoices";
import Customers from "../pages/Business/Customers/Customers";
import Products from "../pages/Business/Products/Products";
import Payment from "../pages/Business/Payments/PaymentLinks";
import VirtualAccount from "../pages/Account/VirtualAccount/VirtualAccount";
import Settlements from "../pages/Account/Settlements/Settlements";
import Balance from "../pages/Balances/Balance/Balance";
import BalanceHistory from "../pages/Balances/BalanceHistory/BalanceHistory";
import RollingReserve from "../pages/Balances/RollingReserve/RollingReserve";
import Transfers from "../pages/Payouts/Transfers/Transfers";
import PendingApprovals from "../pages/Payouts/PendingApprovals/PendingApprovals";
import Beneficiaries from "../pages/Payouts/Beneficiaries/Beneficiaries";
import FundingHistory from "../pages/Payouts/FundingHistory/FundingHistory";
import Refunds from "../pages/Refunds/Refunds";
import Settings from "../pages/Settings/Settings";
import ChargebackTemplate from "../pages/Chargebacks/ChargebacksTemplate/ChargebackTemplate";
import AllChargeback from "../pages/Chargebacks/AllChargeback/AllChargeback";
import PendingChargeback from "../pages/Chargebacks/PendingChargebacks/PendingChargeback";
import AwaitingResponse from "../pages/Chargebacks/AwaitingResponse/AwaitingResponse";
import Won from "../pages/Chargebacks/Won/Won";
import Lost from "../pages/Chargebacks/Lost/Lost";
import Assessment from "../pages/Chargebacks/Assessment/Assessment";
import Terms from "../pages/Compliance/Terms/Terms";
import Home from "../pages/Home/Home";
import OnlineStore from "../pages/OnlineStore/OnlineStore";
import BillPayments from "../pages/BillPayments/BillPayments";
import TransferDetails from "../pages/Payouts/Transfers/TransferDetails/TransferDetails";
import TransferSummary from "../pages/Payouts/Transfers/TransferSummary/TransferSummary";
import BillsPaymentRecords from "../pages/BillPayments/BillsPaymentRecords/BillsPaymentRecords";

export default [
	{
		name: 'home',
		path: '/overview',
		component:
			// <PrivateLayout>
			// 	</>
			// </PrivateLayout>,
			<Home />
	},
	{
		name: 'setup-business',
		path: '/business/onboarding',
		component:
			<KnowYourBusiness />
		,
	},
	{
		name: 'kyc',
		path: '/business/onboarding/kyc',
		component:
			<Kyc>
				<PersonalInfo />
			</Kyc>
		,
	},
	{
		name: 'kyc-personal-info',
		path: '/business/onboarding/kyc/business-info',
		component:
			<Kyc>

				<BusinessInfo />
			</Kyc>
		,
	},
	{
		name: 'terms',
		path: '/business/onboarding/kyc/terms',
		component:
			<Kyc>
				<Terms />
			</Kyc>
		,
	},
	{
		name: 'kyc-bank-details',
		path: '/business/onboarding/kyc/bank-details',
		component:
			<Kyc>

				<BankDetails />
			</Kyc>
		,
	},
	{
		name: 'kyc-business-reg',
		path: '/business/onboarding/kyc/business-registration',
		component:
			<Kyc>

				<BusinessRegistration />
			</Kyc>,
	},
	// {
	// 	name: 'dashboard',
	// 	path: '/dashboard',
	// 	component: 
	//         <Dashboard/>,
	// },
	{
		name: 'transactions',
		path: '/business/transactions',
		component:
			<Transactions />,
	},
	{
		name: 'transactions',
		path: '/business/invoices',
		component:
			<Invoices />,
	},
	{
		name: 'customers',
		path: '/business/customers',
		component:
			<Customers />,
	},
	{
		name: 'products',
		path: '/business/products',
		component:
			<Products />,
	},
	{
		name: 'payments',
		path: '/business/payment-links',
		component:
			<Payment />,
	},
	{
		name: 'virtual-accounts',
		path: '/account/virtual-accounts',
		component:
			<VirtualAccount />,
	},
	{
		name: 'settlements',
		path: '/account/settlements',
		component:
			<Settlements />,
	},
	{
		name: 'balances',
		path: '/balance',
		component:
			<Balance />,
	},
	{
		name: 'balance-history',
		path: '/balance/balance-history',
		component:
			<BalanceHistory />,
	},
	{
		name: 'rolling-serve',
		path: '/balance/rolling-reserve',
		component:
			<RollingReserve />,
	},
	{
		name: 'transfers',
		path: '/transfers',
		component:
			<Transfers />,
	},
	{
		name: 'pending-approval',
		path: '/transfers/pending-approval',
		component:
			<PendingApprovals />,
	},
	{
		name: 'beneficiaries',
		path: '/transfers/beneficiaries',
		component:
			<Beneficiaries />,
	},
	{
		name: 'funding-history',
		path: '/transfers/funding-history',
		component:
			<FundingHistory />,
	},
	{
		name: 'transfer-details',
		path: '/transfers/transfer-details',
		component: <TransferSummary />
	},
	{
		name: 'refunds',
		path: '/refunds',
		component:
			<Refunds />,
	},
	{
		name: 'settings',
		path: '/settings',
		component:
			<Settings />,
	},
	{
		name: 'all-chargebacks',
		path: '/chargebacks/all-chargebacks',
		component:
			<AllChargeback />,
	},
	{
		name: 'pending-chargebacks',
		path: '/chargebacks/pending',
		component:
			<PendingChargeback />,
	},
	{
		name: 'awaiting-response',
		path: '/chargebacks/awaiting-response',
		component:
			<AwaitingResponse />,
	},
	{
		name: 'won',
		path: '/chargebacks/won',
		component:
			<Won />,
	},
	{
		name: 'lost',
		path: '/chargebacks/lost',
		component:
			<Lost />,
	},
	{
		name: 'lost',
		path: '/chargebacks/assessment',
		component:
			<Assessment />,
	},
	{
		name: 'online-store',
		path: '/online-store',
		component:
			<OnlineStore />,
	},
	{
		name: 'bill-payments',
		path: '/bills-payment/initiate',
		component:
			<BillPayments />,
	},
	{
		name: 'bill-payments',
		path: '/bills-payment/history',
		component:
			<BillsPaymentRecords />,
	},

]